<template>
  <div class="page-login">
    <div class="page-top-bg"></div>
    <div class="page-title">登录</div>
    <div class="login-box">
      <div class="box-input">
        <img src="@/assets/images/phone@2x.png" alt="" class="icon-phone">
        <input
          type="email"
          placeholder="请输入账号"
          @input="username.length > 30 ? username=username.slice(0,30) : username"
          v-model="username">
        <img src="@/assets/images/close1@2x.png" alt="" v-show="username" class="icon-close" @click="clear('username')">
      </div>
      <div class="box-input">
        <img src="@/assets/images/suo@2x.png" alt="" class="icon-password">
        <input
          type="password"
          placeholder="请输入密码"
          @input="password.length > 30 ? password=password.slice(0,30) : password"
          v-model="password">
        <img src="@/assets/images/close1@2x.png" alt="" v-show="password" class="icon-close" @click="clear('password')">
      </div>
      <div class="box-submit" role="button" :class="checkSubmit ? 'submit-enabled' : ''" @click="login()">登录</div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { Toast, Indicator } from 'mint-ui'
const Md5 = require('js-md5')
export default{
  data () {
    return {
      username: 'testggfg',
      password: 'a88888888'
    }
  },
  computed: {
    checkSubmit () {
      return (this.username && this.password)
    }
  },
  methods: {
    // 登录
    async login () {
      let that = this
      if (!that.checkSubmit) {
        return
      }
      try {
        Indicator.open()
        let result = await that.$api({
          method: 'post',
          url: '/manage/user/login',
          params: {
            account: that.username,
            password: Md5(that.password)
          }
        })
        Indicator.close()
        if (result.code === 2000) {
          that.setSession('account', result.result.userId || '')
          that.setSession('token', result.result.token || '')
          that.$router.replace({path: '/writeof'})
        } else {
          Toast({
            message: result.message,
            duration: 2000
          })
        }
      } catch (e) {
        console.log(e)
        Indicator.close()
        Toast(e)
      }
    },
    clear (type) {
      this[type] = ''
    }
  },
  created () {
    this.setSession('account', '')
    this.setSession('token', '')
    document.title = '门票预约核销后台'
  }
}
</script>

<style type="text/css" lang="scss" scoped>
.page-login{
  width: 100%;
  height: 100%;
  position: relative;
  background: url('../assets/images/login-top-bg.png') no-repeat top, url('../assets/images/dengluye-di@2x.png') no-repeat bottom;
  background-color: #FFFFFF;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .page-top-bg{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 2.82rem;
  }
  .page-title{
    font-size: .36rem;
    color: #FFFFFF;
    letter-spacing: 0.0154rem;
    text-align: center;
    width: 100%;
    line-height: .5rem;
    margin-top: .29rem;
  }
  .login-box{
    margin-top: .29rem;
    width: 3.45rem;
    height: 3.65rem;
    background: #FFFFFF;
    box-shadow: 0 .02rem .12rem .04rem rgba(207,207,207,0.50);
    border-radius: .08rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .box-input{
      width: 3.25rem;
      height: .44rem;
      background: #E7EFF9;
      border-radius: .225rem;
      margin-top: .48rem;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      ~.box-input{
        margin-top: .25rem;
      }
      input{
        width: 3.25rem;
        height: .4rem;
        border: none;
        outline: none;
        background: transparent;
        font-size: .14rem;
        color: #333333;
        padding-left: .52rem;
      }
      img{
        position: absolute;
      }
      .icon-phone{
        width: .18rem;
        height: .19rem;
        display: block;
        left: .2rem;
      }
      .icon-password{
        width: .16rem;
        height: .2rem;
        display: block;
        left: .2rem;
      }
      .icon-close{
        width: .08rem;
        height: .08rem;
        position: absolute;
        right: .2rem;
      }
      .box-seconds{
        position: absolute;
        font-size: .14rem;
        color: #999999;
        letter-spacing: 0.6px;
        right: .2rem;
        top: 0;
        height: .44rem;
        width: .8rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .seconds-count{
        color: #4384FD;
      }
    }
    .box-submit{
      width: 3.25rem;
      height: .44rem;
      background-image: linear-gradient(270deg, rgba(143,159,191,.27) 0%, rgba(90,121,182,.27) 100%);
      border-radius: .225rem;
      margin-top: .48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .12rem;
      color: #FFFFFF;
    }
    .submit-enabled{
      background-image: linear-gradient(270deg, #6398FF 0%, #3F80FF 100%);
      box-shadow: 0 2px 4px 0 rgba(67,107,196,0.50);
    }
    .box-tips{
      font-size: .12rem;
      color: #999999;
      letter-spacing: 0.51px;
      margin-top: .11rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Admin.vue